import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cmp-layout',
    templateUrl: './layout.component.html',
    standalone: false
})
export class LayoutComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {
  } 
}

  
  